import { useQuery } from '@tanstack/react-query';
import { adminService } from '@/services/admin';
import { Card } from '@/components/ui/Card';

export function TeacherStatsWidget() {
    const { data, isLoading } = useQuery({
        queryKey: ['teacher-attendance-summary-report'],
        queryFn: () => adminService.getTeacherAttendanceSummary({ period: 'monthly' }),
    });

    if (isLoading) return <div className="h-40 bg-slate-50 animate-pulse rounded-xl" />;

    const stats = data?.summary || { total: 0, present: 0, absent: 0, late: 0, leave: 0 };
    const rate = stats.total > 0 ? Math.round((stats.present / stats.total) * 100) : 0;

    return (
        <Card className="p-6">
            <h3 className="text-lg font-bold text-slate-800 mb-6">👩‍🏫 Teacher Attendance Summary (This Month)</h3>
            <div className="grid grid-cols-2 md:grid-cols-4 gap-4">
                <div className="p-4 rounded-lg bg-blue-50 border border-blue-100">
                    <div className="text-sm text-blue-600 font-medium">Avg. Attendance</div>
                    <div className="text-2xl font-bold text-blue-800">{rate}%</div>
                </div>
                <div className="p-4 rounded-lg bg-emerald-50 border border-emerald-100">
                    <div className="text-sm text-emerald-600 font-medium">Present Days</div>
                    <div className="text-2xl font-bold text-emerald-800">{stats.present}</div>
                </div>
                <div className="p-4 rounded-lg bg-rose-50 border border-rose-100">
                    <div className="text-sm text-rose-600 font-medium">Absences</div>
                    <div className="text-2xl font-bold text-rose-800">{stats.absent}</div>
                </div>
                <div className="p-4 rounded-lg bg-amber-50 border border-amber-100">
                    <div className="text-sm text-amber-600 font-medium">Late Arrivals</div>
                    <div className="text-2xl font-bold text-amber-800">{stats.late}</div>
                </div>
            </div>
        </Card>
    );
}
